import { HUBSPOT_VIDEO_FEEDBACK_EVENTS } from '@/shared/thirdParty/hubSpot';

export const OPTIONS = [
  {
    label: 'Inaccurate speech-to-text recognition 📝',
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.transcriptionProblem,
  },
  {
    label: 'Poor text translation 🗺️',
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.translationProblem,
  },
  {
    label: 'Speaker voice assigned incorrectly 👨👩',
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.speakerSeparation,
  },
  {
    label: 'Original and translated audio mismatch (e.g. speed, pauses) 💬',
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.unsynchronization,
  },
  {
    label: 'Robotic voice 🤖',
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.roboticVoice,
  },
  {
    label: "Voice Clone doesn't sound like the original voice 😞",
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.notClonedVoice,
  },
  {
    label: 'Wrong accent in voice 🎙',
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.accent,
  },
  {
    label: 'Background noise 🌫',
    hubSpotEvent: HUBSPOT_VIDEO_FEEDBACK_EVENTS.backgroundNoise,
  },
];

export const TTS_OPTIONS = [
  { label: 'Flat and monotonous voice 😐' },
  { label: 'Pronounciation errors 🗣️' },
  { label: 'Mismatch in voiceover accent 🎙️' },
  { label: 'Low sound quality 🔈' },
  { label: 'Noise distortions 💥' },
  { label: 'Limited voice options 🤏' },
  { label: 'Voice clone doesn’t sound like the original voice 🤷' },
];
